// import React from "react";
import logo from "../logo.svg";
import ResponsiveNavbar from "./ResponsiveNavBar";

import {
	Container,
	Row,
	Col,
	Form,
	Input,
	Button,
	Navbar,
	Nav,
	NavbarBrand,
	NavLink,
	NavItem,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "react-bootstrap";

import {  Typography } from '@mui/material'
import React, { Component } from 'react'

// const Footer = () => (
//     <footer className="foot bg-dark text-white p-4 text-center">
//     <Container>
//       <Row>
//         <Col md="4">
          
//         </Col>
//         <Col md="4">
          
//           <p>Email: surya@sethu-ai.com</p>
          
//         </Col>
//         <Col md="4">
         
//         </Col>
//       </Row>
      
//     </Container>
//   </footer>
// )


// export default Footer;

export class Footer extends Component {
	render() {
	  return ( 
		  <footer style={{ padding: '1rem 0'}} >
		  <Container maxWidth="lg">
			<Typography variant="body2" color="textSecondary" align="center" >
			  &copy; {new Date().getFullYear()} Sethu-AI. All rights reserved.
			</Typography>
			
			<Typography variant="body2" color="textSecondary" align="center">
			  Need assistance? <a href="mailto:Surya@sethu-ai.com">Contact Support</a>
			</Typography>
		  </Container>
		</footer>
	  )
	}
  }
  
  export default Footer